import ShopEntity from './base.js';
// import mpro from '../mpro.init';

export default class Addresses extends ShopEntity {

	/**
	 * @typedef {(resp: import('../ajax-entities/addresses').MpApiLookupResponseData) => void} MpLookupDelayedCallback
	 * @typedef {{ items: import('../ajax-entities/addresses').MpApiLookupItem[], callback: MpLookupDelayedCallback }} MpLookupData
	 */

	static get NAME() {
		return 'Addresses';
	}

	/** @type {MpLookupData[]} */
	queue = [];
	/** @type {number} */
	timer;

	actions = {

		// Use base actions
		...this.actions,

		// Redirect to /addresses
		/** @type {import('./base').ShopActionHandler} */
		redirect_addresses: (args) => {
			mpro.setLocation(mpro.config.routes.addresses);
		},
		// Update default addresses
		/** @type {import('./base').ShopActionHandler} */
		update_default_addresses: (args, actionType, res, triggerElement) => {
			if (res?.data?.address_id > 0) {
				if (actionType === 'shipping_address_default') {
					$('[data-shipping-address-default]').attr('data-confirm', '').find('input').removeAttr('checked');
					$('[data-shipping-address-default][data-address-id=' + res.data.address_id + ']').removeAttr('data-confirm').find('input').attr('checked', 'checked');
				}
				else if (actionType === 'billing_address_default') {
					$('[data-billing-address-default]').attr('data-confirm', true).find('input').removeAttr('checked');
					$('[data-billing-address-default][data-address-id=' + res.data.address_id + ']').removeAttr('data-confirm').find('input').attr('checked', 'checked');
				}
				$('[data-address-delete]').removeClass('disabled');
				$('[data-shipping-address-default],[data-billing-address-default]')
					.find('input:checked')
					.closest('[data-address-container]')
					.find('[data-address-delete]')
					.addClass('disabled');
			}
		},
		// Update default addresses
		/** @type {import('./base').ShopActionHandler} */
		address_delete: (args, actionType, res, triggerElement) => {
			console.log(res);
			if (res?.data?.address_id > 0) {
				$('[data-address-delete][data-address-id=' + res.data.address_id + ']').closest('[data-address-container]').hide('fast', function() {
					$(this).remove();
				});
			}
		},
	};

	constructor() {
		super();
		// Assign the api
		this.api = mpro.ajax.addresses;
	}

	shipping_address_default(data) {
		return this.api.shipping_address_default(data);
	}

	billing_address_default(data) {
		return this.api.billing_address_default(data);
	}

	address_delete(data) {
		return this.api.address_delete(data);
	}
}
